import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scroll to top on route change unless there's a hash anchor
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
}
